<template>
  <v-container fluid class="overflow-y-auto">
    <v-row>
      <v-col cols="12" class="titleLarge d-flex align-center">
        <p class="opacity87">{{ $t('views.fobs.title') }}</p>
      </v-col>
    </v-row>

    <p class="mt-2 bodyTexts blue_colored">
      {{ $t('views.fobs.graph') }}
    </p>
    <RightBarFobsGraph :incident-fobs="incidentFobs" @selected="loadSelectedFob" />
    <p v-if="selectedFob" class="mt-2 bodyTexts blue_colored">
      {{ $t('views.fobs.details') }}
    </p>
    <RightBarFobsDetails v-if="selectedFob" :incident="incident" :index="dataIndexRef" :fob="selectedFob" />
    <v-btn
      v-if="
        authStore.hasPermission('fobs-create') &&
        authStore.user &&
        incident &&
        incidentStore.isFromUserOrganization(authStore.user, incident)
      "
      icon="mdi-plus"
      color="rgb(var(--v-theme-primary))"
      size="large"
      class="absolute"
      @click="openNewObservation"></v-btn>
  </v-container>
</template>

<script setup lang="ts">
// Framework import
import type { Ref } from 'vue'
import { onBeforeMount, ref, watch } from 'vue'

// Component Import

// Fobs import
import { storeToRefs } from 'pinia'

import { getObservations } from '@/services/api/fobs'

// Stores import
import AuthStore from '@/stores/auth'
import IncidentStore from '@/stores/incidentStore'
import type { IncidentFob } from '@/types/Fobs'

import RightBarFobsDetails from './RightBarFobsDetails.vue'
import RightBarFobsGraph from './RightBarFobsGraph.vue'

const incidentStore = IncidentStore()
const authStore = AuthStore()

const { incident } = storeToRefs(incidentStore)

const emits = defineEmits<{
  (event: 'openNewObservationEvent'): void
}>()

const incidentFobs = ref([] as Array<IncidentFob>)

const selectedFob: Ref<IncidentFob | null> = ref(null)
onBeforeMount(async () => await loadFobs())

watch(incident, async () => {
  await loadFobs()
})

async function loadFobs() {
  selectedFob.value = null
  if (!incident.value) return
  try {
    incidentFobs.value = await getObservations(incident.value.id)
  } catch (e) {
    console.error('fobs', e)
  }
}

const openNewObservation = () => {
  emits('openNewObservationEvent')
}

const dataIndexRef = ref(0 as number)

const loadSelectedFob = (dataId: string) => {
  selectedFob.value = incidentFobs.value.find((x) => x.id === dataId) ?? null
}
</script>

<style scoped lang="scss">
.absolute {
  position: absolute;
  bottom: 31px;
  right: 27px;
}
</style>
